<template>
  <!--eslint-disable-->
  <v-card class="bio" flat>
    <v-card-title v-if="showEdit">
      {{ title }}
      <v-spacer></v-spacer>
      <v-btn
        :color="!isEdit ? 'primary' : 'indigo'"
        dark
        @click="!isEdit ? (isEdit = !isEdit) : editBioData()"
      >
        <v-icon class="mx-2">{{ !isEdit ? "edit" : "save" }}</v-icon>
        {{ !isEdit ? "edit" : "Save" }}
      </v-btn>
    </v-card-title>
    <div class="form">
      <v-form v-model="isValid" ref="bioDataForm">
        <v-card-text>
          <v-row>
            <v-col cols="12" md="4" class="d-flex">
              <v-avatar rounded size="80" class="me-6">
                <v-img
                  v-if="!formData.base64Image"
                  src="../../../assets/images/2.png"
                />
                <v-img
                  v-else
                  :src="`data:${getImage(formData.base64Image)};base64,${
                    formData.base64Image
                  }`"
                />
              </v-avatar>
              <!-- upload photo -->
              <div class="pa-1 ma-2">
                <v-file-input
                  prepend-icon=""
                  type="file"
                  rounded
                  filled
                  dense
                  :disabled="!isEdit"
                  @change="uploadProfilePicture($event)"
                  :background-color="`green`"
                  id="fileUpload"
                  placeholder="Upload Profile Picture"
                  accept=".jpeg,.png,.jpg,GIF"
                />
              </div>
            </v-col>
            <v-col cols="12" md="8">
              <v-row>
                <v-col cols="12" md="4" sm="6">
                  <v-text-field
                    v-model="formData.firstName"
                    outlined
                    dense
                    prepend-inner-icon="account_circle"
                    placeholder="Enter Your FirstName"
                    label="First Name"
                    :rules="rules.required"
                    :disabled="!isEdit"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4" sm="6">
                  <v-text-field
                    v-model="formData.secondName"
                    outlined
                    dense
                    placeholder="Enter Your Middle Name"
                    label="Middle Name"
                    prepend-inner-icon="account_circle"
                    :disabled="!isEdit"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4" sm="6" xs="12">
                  <v-text-field
                    v-model="formData.lastName"
                    outlined
                    dense
                    placeholder="Enter Your Last Name"
                    label="Last Name"
                    prepend-inner-icon="account_circle"
                    :rules="rules.required"
                    :disabled="!isEdit"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4" sm="6" class="mt-n6">
                  <p class="text--primary mt-n3 mb-2">Gender</p>
                  <v-radio-group
                    row
                    :rules="rules.required"
                    class="mt-0"
                    hide-details
                    v-model="formData['gender']"
                  >
                    <v-radio
                      v-for="gen in gender"
                      :key="gen.name"
                      :label="gen.name"
                      :value="gen.name"
                    ></v-radio>
                  </v-radio-group>
                </v-col>
                <v-col cols="12" md="4" sm="6" class="mt-n6">
                  <v-menu
                    v-model="menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="formData.dateOfBirth"
                        label="Date of Birth"
                        prepend-inner-icon="mdi-calendar"
                        outlined
                        dense
                        readonly
                        :rules="rules.required"
                        v-bind="attrs"
                        v-on="on"
                      />
                    </template>
                    <v-date-picker
                      v-model="selectedDate"
                      min="1950/01/01"
                      :allowed-dates="
                        (date) => date <= new Date().toISOString().substr(0, 10)
                      "
                      @input="menu = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="4" sm="6" class="mt-n6">
                  <v-text-field
                    v-model="contactFormData.address"
                    placeholder="Enter Address"
                    label="Address"
                    prepend-inner-icon="house"
                    outlined
                    persistent-placeholder
                    dense
                    :rules="rules.required"
                    :disabled="!isEdit"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12">
              <v-row>
                <!--formData-->
                <v-col cols="12" md="4" sm="6" class="mt-n6">
                  <v-select
                    v-model="nationalityCode"
                    :items="countries"
                    :rules="rules.required"
                    label="Nationality"
                    item-text="name"
                    item-value="code"
                    dense
                    outlined
                    prepend-inner-icon="flag"
                    :disabled="!isEdit"
                  ></v-select>
                </v-col>
                <v-col cols="12" md="4" sm="6" class="mt-n6">
                  <v-select
                    v-model="contactFormData.countyCode"
                    :items="counties"
                    label="County"
                    item-text="countyName"
                    item-value="countyNo"
                    dense
                    outlined
                    prepend-inner-icon="mdi-map-marker"
                    :disabled="!isEdit"
                    :rules="rules.required"
                  ></v-select>
                </v-col>
                <!-- contact form -->
                <v-col cols="12" md="4" sm="6" class="mt-n6">
                  <!-- upload avatar -->
                  <v-file-input
                    label="Upload Passport/ National ID"
                    placeholder="ID"
                    dense
                    outlined
                    type="file"
                    @change="uploadNationalID($event)"
                    prepend-icon=""
                    prepend-inner-icon="badge"
                    accept="image/jpeg,image/png,application/pdf"
                  >
                    <template v-slot:selection="{ text }">
                      <v-chip color="green accent-4" dark label small>
                        {{ text }}
                      </v-chip>
                    </template>
                  </v-file-input>
                </v-col>
                <!-- emergency contact information -->
                <v-col cols="12" md="4" sm="6" class="mt-n6">
                  <v-text-field
                    v-model="emergencyContact.eMail"
                    :rules="rules.email"
                    label="Emergency Email"
                    dense
                    outlined
                    prepend-inner-icon="email"
                    :disabled="!isEdit"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4" sm="6" class="mt-n6">
                  <v-text-field
                    v-model="emergencyContact.address"
                    label="Emergency Address"
                    dense
                    outlined
                    prepend-inner-icon="home"
                    :disabled="!isEdit"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4" sm="6" class="mt-n6">
                  <v-text-field
                    v-model="emergencyContact.phoneNo"
                    :rules="rules.phoneNo"
                    label="Emergency Phone"
                    dense
                    outlined
                    prepend-inner-icon="phone"
                    :disabled="!isEdit"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-form>
    </div>
  </v-card>
</template>

<script>
// import FileUpload from "../../dashboard/components/FileUpload.vue";
import helpers from "../../dashboard/utils/helpers/helper.js";
import FileMixin from "@brainspore/celadon-base/mixin/FileMixin";

export default {
  name: "BioData",
  mixins: {
    FileMixin,
  },
  props: {
    isEdit: {
      default: true,
      type: Boolean,
    },
    title: {
      default: "",
      type: String,
    },
    showEdit: {
      default: false,
      type: Boolean,
    },
  },
  data: () => ({
    menu: false,
    file: null,
    updateAttachments: false,
    updateImage: false,
    formData: {
      gender: "",
      nationalityCode: "",
      identificationDocumentNo: "",
      base64Id: "",
      dateOfBirth: "",
      base64Image: "",
      profileID: "",
      lastName: "",
      firstName: "",
      secondName: "",
    },
    contactFormData: {
      eMail: "",
      phoneNo: "",
      address: "",
      countryCode: "",
      countyCode: "",
      profileID: "",
      versionNo: 0,
      type: "Personal",
    },
    emergencyContact: {
      eMail: "",
      phoneNo: "",
      address: "",
      type: "Emergency",
      profileID: "",
      versionNo: 0,
    },
    gender: [
      {
        name: "Male",
        value: "male",
      },
      {
        name: "Female",
        value: "female",
      },
    ],
    displayOptions: { elevation: "0", isEdit: false },
    fileStatus: "default",
    isValid: false,
  }),
  beforeRouteEnter(to, from, next) {
    next((v) => {
      v.$store.dispatch("Profile/getProfile");
      v.$store.dispatch("Profile/getAllSetup");
    });
  },
  mounted() {
    Event.$on("editBioData", () => {
      this.editBioData();
    });
  },
  computed: {
    bioData() {
      return this.$store.getters["Profile/bioData"];
    },
    countries: function () {
      return this.$store.getters["Profile/setupGetter"]("countries");
    },
    counties: function () {
      return this.$store.getters["Profile/setupGetter"]("counties");
    },
    contact: function () {
      return this.bioData.userContacts
        ? this.bioData.userContacts.filter(
            (item) => item.type === "Personal" && item.status === "Active",
          )[0]
        : null;
    },
    emergency: function () {
      return this.bioData.userContacts
        ? this.bioData.userContacts.filter(
            (item) => item.type === "Emergency" && item.status === "Active",
          )[0]
        : null;
    },
    nationalityCode: {
      get() {
        return this.formData.nationalityCode;
      },
      set(value) {
        this.formData.nationalityCode = value;
        this.contactFormData.countryCode = value;
      },
    },
    fileAttachment: {
      get() {
        return this.file;
      },
      set(value) {
        this.file = value;
        helpers.toBase64(value).then((res) => {
          this.formData.base64Image = res.split(",")[1]; // avatar
        });
      },
    },
    selectedDate: {
      get() {
        return "";
      },
      set(value) {
        this.formData.dateOfBirth = value;
      },
    },
    rules() {
      return {
        required: [(v) => !!v || "field is required"],
        email: [
          (v) =>
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
              v,
            ) ||
            !v ||
            "E-mail must be valid",
        ],
        phoneNo: [
          (v) =>
            !v ||
            /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.test(v) ||
            "Invalid phone number format",
        ],
        files: (file) =>
          !file ||
          file.size < 20000000 ||
          "File size should be less than 10 MB!",
      };
    },
  },

  watch: {
    bioData() {
      // mapping bio-data
      Object.keys(this.formData).map((item) => {
        if (this.bioData[item]) {
          this.formData[item] = this.bioData[item];
        }
      });
      // mapping user contacts
      Object.keys(this.contactFormData).map((item) => {
        if (this.contact) {
          this.contactFormData[item] = this.contact[item];
          this.contactFormData["versionNo"] = 0;
        }
      });
      // mapping user emergency contact
      if (this.emergency)
        Object.keys(this.emergencyContact).map((item) => {
          if (this.emergency[item]) {
            this.emergencyContact[item] = this.emergency[item];
            this.emergencyContact["versionNo"] = 0;
          }
        });
    },
    contact: {
      handler: function () {
        this.contactFormData.eMail = this.bioData.email;
        this.contactFormData.phoneNo = this.bioData.phoneNo;
      },
    },
  },

  methods: {
    editBioData() {
      if (!this.isValid) {
        this.$refs.bioDataForm.validate();
        this.$emit("moveNext", false);
      } else {
        if (this.fileError) {
          Event.$emit("ApiError", "File Is greater than 2mbs");
          this.$emit("moveNext", false);
        } else {
          this.emergencyContact.profileID = this.bioData.profileID;
          this.contactFormData.profileID = this.bioData.profileID;
          this.formData.profileID = this.bioData.profileID;
          const data = {
            bioData: { ...this.formData },
            emergency: { ...this.emergencyContact },
            personal: { ...this.contactFormData },
          };
          this.$store.dispatch("Profile/updateNested", data);
          this.setAttachments(false);
          setTimeout(() => {
            this.$emit("moveNext", true);
          }, 3000);
        }
      }
    },
    getImage(base64) {
      return helpers.detectMimeType(base64);
    },
    async uploadProfilePicture(event) {
      let attachment = await helpers.toBase64(event);
      this.formData.base64Image = attachment.split(",")[1];
    },
    // upload national ID (change this method to use one upload method)
    async uploadNationalID(event) {
      let attachment = await helpers.toBase64(event);
      this.formData.base64Id = attachment.split(",")[1];
    },
    setAttachments(val) {
      this.updateAttachments = val;
      this.updateImage = val;
    },
  },
};
</script>

<style>
.bio--button > .v-btn__content {
  font-size: 16px;
  text-transform: none;
}
.bio {
  font-family: "PT Sans Caption", sans-serif;
  cursor: progress;
  width: 100%;
  margin: 0 auto;
}
</style>
